import { JSX } from 'preact'
import { memo } from 'preact/compat'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useTemplateTags } from '../useTemplateTags'
import { useFormContext } from '../Form/useFormContext'
import { useComponentStyle } from '../Style'

// see https://github.com/preactjs/preact/issues/3171
const Option = memo(({ value, label }: { value: string; label: string }) => {
  return <option value={value}>{label}</option>
})

export function Select({ name, required, options = [], ...props }: TBlockProps<BlockType.Select>): JSX.Element {
  const { template } = useTemplateTags()
  const { getValue, setValue } = useFormContext()
  const { classes } = useComponentStyle('input-select', props)

  const value = getValue(name)
  const className = classnames(classes, { selected: !!value })

  const handleChange = (e: Event) => {
    const val = (e.target as HTMLInputElement).value
    setValue(name, { value: [val] })
  }

  return (
    <div className={className}>
      <select required={required} name={name} value={value} onChange={handleChange}>
        {(!value || !required) && <Option value={''} label={'---'} />}
        {options.map(({ value, label }) => (
          <Option key={value} value={value} label={template(label)} />
        ))}
      </select>
    </div>
  )
}
